module.exports = __webpack_public_path__ + "static/img/quan_1.d502bd04.png";